<app-headnav [user]="current" (info)="onInfo($event)" [logOutFlag]="logOutFlag" (getLogo)="onSavedLogo($event)">
</app-headnav>
<div *ngIf="!userId" class="studio">
</div>
<div id="overlay" style="background: black url('/assets/images/loader.gif') center center no-repeat;"></div>

<div *ngIf="userId" class="studio">
<!--<div class="header">
      <div class="logo d-flex align-items-center">   
        <a href="https://www.erisinfo.com/ca/" target=_blank>
       <img class="img ml-2" src="../assets/images/logo.png" alt="logo"  height="40"/>
      </a>
      </div>
      <div class="info">
      </div>
      <div class="toolbar">
          <a href="javascript:void(0)" class="toolbar-item" (click)="preview()">            
            <i class="far fa-eye" aria-hidden="true"style="font-size: 24px;"></i>		
          </a>
          <a href="javascript:void(0)" class="toolbar-item">            
            <i class="far fa-save" aria-hidden="true"style="font-size: 24px;"></i>		
          </a>
          
        <a href="javascript:void(0)" class="toolbar-item" >
          <i class="fas fa-print" style="font-size: 24px;"></i>
        </a>
         
        <button class="ml-3 btn btn-secondary">
          username
        </button>       
      </div>
    </div>-->
	<div class="sidenav flex-container">
		<div class="sidenav flex-container" [style.width]="sideNavWidth">
			<a href="dashboard" title="Dashboard" target=_blank>
			<!--span aria-hidden="true" data-icon="&#xe90a;" class="icon-dashboard" style="font-size:32px"></span-->
			<span data-icon="&#xe90a;" class="icon-dashboard" style="font-size:32px">
			</span>
			<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Dashboard</span>

			</a>
			<!-- <a href="report" title="Report Writer" target=_blank><i class="far fa-edit"></i></a><i class="fas fa-tachometer-alt"></i> -->
			<a href="cover" title="Cover Page" class="active" target=_blank><i class="icon-Cover" style="font-size:32px"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Cover, Header & Footer</span>
			</a>
			<a href="template" title="Template" target=_blank><i class="icon-Template" style="font-size:32px"></i>
				<span aria-hidden="true" style="position: absolute; left: 86px">Templates</span>

			</a>
			<!--<a href="complete" title="Completed Reports" target=_blank>
				<i style="margin-left: 5px" class="far fa-list-alt"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Complete Reports</span>
			</a>-->
			<a href="company" style="border-top: 1px solid #000000;" title="Company" target=_blank><i class="icon-property" style="font-size:32px"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Company Info</span>

			</a>
					
			<a title="Libraries" href="resources" style="border-top: 1px solid #000000" target=_blank>
			<span aria-hidden="true" data-icon="&#xe90f;" class="icon-Libraries" style="font-size:32px; margin-left:5px"></span>
			<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Libraries</span>

			</a>
			<!--<a *ngIf="userInfo.ERIS_STAFF=='Y'" title="ERIS" href="erisonly" style="border-top: 1px solid #000000" target=_blank>
				<i  class="icon-eris" style="font-size: 32px;"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">ERIS Only</span>

				</a>-->

			<a  (click)="toggleSideBar()"> 

				<i *ngIf="!toggleSideBarVar" class="pi pi-chevron-right" style="font-size: 24px;"></i>
				<i  *ngIf="toggleSideBarVar"class="pi pi-chevron-left" style="font-size: 24px;"></i>

			</a>			
		</div>
	</div>
<div class="main">
<div *ngIf="htmlCShow" id="html-box" class="html-box" cdkDrag  [cdkDragDisabled]="dragDisabled">
		<div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:12px"> 
			<div style="width: 500px; margin: 10px; padding-right:0; color:white; height:600px"> 
				<label style="font-size:16px; font-weight:bold">Source Viewer</label>
			
				<a href='javascript:void(0)' class="btn btn-outline-light btn-sm ml-4 pt-0 pb-0" (click)='testCHtml(cIndex)'>Test HTML</a>
				<button type="button"   style="float:right" (click)="htmlCShow=false">&times;</button>
				<hr>
				<textarea class="col-md-12" rows=24 [(ngModel)]="sourceCCode[cIndex]" (mouseenter)="setDrag(1)" (mouseout)="setDrag(0)" placeholder="Paste your html code here."></textarea>	
			</div>        
        
												
			
		</div>					
	</div>
	<div *ngIf="htmlShow" id="html-box" class="html-box" cdkDrag  [cdkDragDisabled]="dragDisabled">
		<div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.9em"> 
			<div style="width: 500px; margin: 10px; padding-right:0; color:white; height:600px"> 
			<label style="font-size:16px; font-weight:bold">Source Viewer</label>
			
			<a href='javascript:void(0)' class="btn btn-outline-light btn-sm ml-4 pt-0 pb-0" (click)='testHtml()'>Test HTML</a>
          	<button type="button"  style="float:right" (click)="htmlShow=false">&times;</button>
			<hr>
			<textarea class="col-md-12" rows=24 [(ngModel)]="sourceHFCode" (mouseenter)="setDrag(1)" (mouseout)="setDrag(0)"  placeholder="Paste your html code here."></textarea>	
        </div>        
        
												
			
		</div>					
	</div>
<div class="row container-fluid p-0 m-0" style="height:100%; overflow:auto">
<div class="col-md-3 contentContainer">
<p-table #tb [columns]="cols2" [value]="groupSlots" dataKey="CATEGORY" sortMode="single" [expandedRowKeys]="expandedRows"><!-- (onPage)="onPage($event)" (onRowExpand)="onRowExpand()" (onRowCollapse)="onRowCollapse()"-->
    <ng-template pTemplate="caption">
	<div style="display:inline-block">
		<a style="cursor: pointer;font-size: 16px; color:rgb(195,212,47);" (click)="expandAll()">
			<i *ngIf="!isExpanded" class="fas fa-angle-double-right"></i>
			<i *ngIf="isExpanded" class="fas fa-angle-double-down"></i>
		</a>
	</div>
        <div style="float: right; display:inline-block">        
            <!--<i class="pi pi-search" style="margin:4px 4px 0 0"></i>
            <input type="text" pInputText size="10" placeholder="Filter" (input)="tb.filterGlobal($event.target.value, 'contains')" style="width:auto">-->
			<input type="text" pInputText size="10" placeholder="Filter" (change)="filterSlots($event)" style="width:auto">
			<i class="pi pi-search" style="margin:4px 4px 0 0" (click)='filterSlots($event)'></i>	
		</div>
    </ng-template>
	
    <ng-template pTemplate="body" let-rowData let-expanded="expanded" let-columns="columns">
        <tr style="font-size:12px"><!-- [pSelectableRow]="rowData" -->
            <td>
                <a href="#" [pRowToggler]="rowData">
                    <i [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
                </a>
            </td>
            <td *ngFor="let col of columns"  style="padding:6px"  [ngStyle]="{'width': col.width}">
				<ng-container *ngIf="col.field=='CATEGORY'">
					{{rowData.CATEGORY}}					
				</ng-container>               
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-rowData let-columns="cols3">
        <tr>
            <td [attr.colspan]="cols2.length + 1" style="padding:0">
				<ng-container *ngFor="let r of rowData.RW_SLOTS">
					<div *ngIf="r.STATUS=='Active'" class="card" style="margin:10px 0"> 
						<div class="row"  style="width:100%; padding:0 0 0 16px;">
							<label style="width:85%; margin-top:8px;color:rgb(195,212,47);">{{r.KEY}}<span style="color:#04B486; margin:0 2px">({{r.TYPE}})</span>
							<i *ngIf="r.SYSTEM_IND=='Y'" class="fas fa-globe"></i>
							<i *ngIf="r.SYSTEM_IND=='N'" class="fas fa-cog"></i></label>
							
							<a *ngIf="r.CONTENT.length>0" href="javascript:void(0)" style="width:5%; margin-top:2px; float:right" title="Content" (click)="op1.toggle($event);" ><i class="fas fa-eye"></i></a>					
							<a *ngIf="addLib" href="javascript:void(0)" style="width:5%; margin-top:2px" class="btn btn-link btn-sm pt-0 pb-0 pl-1 pr-1" title="Add to Doc"><i class="fas fa-arrow-right" (click)="addRepeat(r)"></i></a>
							<a href="javascript:void(0)" style="width:5%; margin-top:2px" class="btn btn-link btn-sm pt-0 pb-0 pl-1 pr-1" title="Copy"><i class="btn-blue far fa-copy" (click)="copyRepeat(r)"></i></a>							
							
							<p-overlayPanel #op1 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '400px'}" (onShow)="getTable(r.TYPE, r.CONTENT)">
                                                <ng-template pTemplate>
                                                    <div style="margin: 10px; color:#C2D63F; max-height:400px; overflow:auto; font-size:.9em"> 
													<strong>{{r.KEY}}</strong><br>
													<strong>Category : </strong> 
													<span style="color:white">{{r.CATEGORY}}</span><br>
													<strong>Type : </strong> 
													<span style="color:white">{{r.TYPE}}</span><br>
														<strong *ngIf="(r.TYPE!='Table')&&(r.TYPE!='Selection')">Content : </strong> 
														<!--<span *ngIf="(r.TYPE!='Table')&&(r.TYPE!='Selection')">{{r.CONTENT}}</span>-->
														<div *ngIf="(r.TYPE!='Table')&&(r.TYPE!='Selection')">
															<span style="color:white">{{r.CONTENT}}</span>
														</div>
														<div *ngIf="r.TYPE=='Selection'">
															<strong>Options : </strong><br>
															<ng-container *ngFor="let item of tableContent">
																<span style="color:white">. {{item}}</span><br>
															</ng-container>
														</div>
														<div *ngIf="r.TYPE=='Table'">
															<strong>Headers of Table</strong>
															<table style="color:white; width:90%; border: 1px solid black;  border-collapse: collapse;">
															<thead>
																<tr>
																<th>No.</th>
																<th>Name</th>
																<th>Type</th>
																</tr>
															</thead>
															<tbody>
																<ng-container *ngFor="let item of tableContent; let i=index">
																	<tr>
																	<td>{{i}}</td>
																	<td>{{item.NAME}}</td>
																	<td>{{item.TYPE}}</td>
																	</tr>
																</ng-container>
															</tbody>
															</table>
														</div>
													</div>
                                                </ng-template>
                                            </p-overlayPanel>
					<br><span>{{r.SHORT_CONTENT}}</span>
					</div>
				</div>
				
				</ng-container>
				
            </td>
           
        </tr>
    </ng-template>
</p-table>
</div>
<div class="col-md-7 editContainer">
<div class="where_you_want_to_inject">   
  <ng-template appInject></ng-template>
</div>
<div class="tool  sticky-top">
<button class="btn btn-dark btn-sm mr-1" title="Portrait" [ngStyle]="{'border':selectpage.type==='portrait'? '1px solid yellow':'none'}" (click)="selectPage('portrait')"><i class="fas fa-arrows-alt-v"></i>
</button>
<button class="btn btn-dark btn-sm mr-1" title="Landscape" [ngStyle]="{'border':selectpage.type==='landscape'? '1px solid yellow':'none'}" (click)="selectPage('landscape')"><i class="fas fa-arrows-alt-h"></i>
</button>
<button class="btn btn-dark btn-sm mr-1" title="Margin" data-target='#marginModal' data-toggle="modal"><i class="fas fa-arrows-alt"></i>
</button>
<!--<span style="color:white">DPI : </span>
<select  [(ngModel)]='selectPdi'>
	<option [selected]='selectPdi=="300"'>300</option>
	<option [selected]='selectPdi=="600"'>600</option>
	<option [selected]='selectPdi=="900"'>900</option>
	<option [selected]='selectPdi=="1200"'>1200</option>	
</select>
<span style="color:white; margin-left:6px">Default Font : </span>
<select  [(ngModel)]='selectFont'>
	<option [selected]='selectFont=="Arial"'>Arial</option>
	<option [selected]='selectFont=="Courier New"'>Courier New</option>
	<option [selected]='selectFont=="Georgia"'>Georgia</option>
	<option [selected]='selectFont=="Lucida Sans Unicode"'>Lucida Sans Unicode</option>
	<option [selected]='selectFont=="Tahoma"'>Tahoma</option>
	<option [selected]='selectFont=="Times New Roman"'>Times New Roman</option>
	<option [selected]='selectFont=="Trebuchet MS"'>Trebuchet MS</option>
	<option [selected]='selectFont=="Verdana"'>Verdana</option>	
</select>
<select  [(ngModel)]='lineSpace' title="Line Space">
	<option [selected]='lineSpace=="0"'>0</option>
	<option [selected]='lineSpace=="1"'>1</option>
	<option [selected]='lineSpace=="2"'>2</option>
	<option [selected]='lineSpace=="3"'>3</option>	
</select>
<button class="btn btn-dark btn-sm ml-1 mr-1" title="Generate PDF" data-target='#orderModal' data-toggle="modal"><i class="far fa-file-pdf"></i>
</button>
<button class="btn btn-dark btn-sm mr-1" title="Upload" data-target='#fileModal' data-toggle="modal" title="Upload Image"><i class="fas fa-cloud-upload-alt"></i>
</button>-->
<span *ngIf="editType=='H'" class="topLabel">Header Height: <input [(ngModel)]="hHeight" type="number" maxlength=4 style="width:60px">px
</span>
<span *ngIf="editType=='F'" class="topLabel">Footer Height: <input [(ngModel)]="fHeight" type="number" maxlength=4 style="width:60px">px
</span>
</div>
<div class="pageContainer">

<ng-container *ngFor="let page of pages let i=index">
	<div *ngIf="editType=='C'&&dataInput=='ck'" class="example-list"  #viewer [ngStyle]="{'background': page.bk?.length>0? 'url(' + page?.bk + ')':'#FFFFFF'}" [style.padding-top.px]="pageMargin.top" [style.padding-bottom.px]="pageMargin.bottom" [style.padding-left.px]="pageMargin.left" [style.padding-right.px]="pageMargin.right" [style.width.px]="selectpage.size.width" [style.height.px]="selectpage.size.height" >
			<!--<ng-container *ngIf="item.hData">
				<div  class='comp cktest' [innerHTML]="item.hData"  [style]="item.hstyle"  (click)="toImage($event)"></div>
			</ng-container>-->
			<ng-container *ngIf="page.eData">
				<div class="ckContainer cktest editorRange">
					<app-paragraph [addedSlot]="addedSlot[i]" class="docItem" [content]="page.eData" [insert]='selectedInsert[i]' (onExit)="ckData($event,page.index, i)" (selected)="addLib=true;  selectedEditor='C'; selectIndex=i "></app-paragraph>
				<!--<button class="btn btn-outline-light float-btn ml-1" (click)="showsavedSlot()">Repeat Fields</button>-->					
				</div>
			</ng-container>	
		
	</div>
	<div *ngIf="editType=='C'&&dataInput=='HTML'" class="example-list"  #viewer1 [style.padding-top.px]="pageMargin.top" [style.padding-bottom.px]="pageMargin.bottom" [style.padding-left.px]="pageMargin.left" [style.padding-right.px]="pageMargin.right" [style.width.px]="selectpage.size.width" [style.height.px]="selectpage.size.height" >
			<ng-container *ngIf="page.eData">
				<div class="ckContainer cktest editorRange pt-3">
					<label class="sampleTitle ml-3">Cover Page {{i+1}}: </label>
					<button  [disabled]="allowEdit!='Y'"class="btn btn-sm btn-outline-dark mr-3 pb-0 float-sm-right" (click)='editCHtml("cover",i); htmlCShow=true; cIndex=i'>Editor Html</button>
            		<!--<div *ngIf="savedCHTML[i]" class="container" style="border:dashed 1px #ccc;height:1056px; border:1px dashed #ccc; overflow:hidden; padding:0; width:816px; margin:0" [innerHTML]="savedCHTML[i]?.changingThisBreaksApplicationSecurity|safeHtml">
					</div>-->
					<div class="iframewrapper">
						<iframe *ngIf="savedCHTML[i]?.changingThisBreaksApplicationSecurity" frameborder="0"  style="width:100%;border:dashed 1px #ccc;min-height:1086px; margin: 0;padding: 0;overflow:hidden" [srcdoc]="savedCHTML[i]?.changingThisBreaksApplicationSecurity|safeHtml"></iframe>
					</div>
				</div>
			</ng-container>	
		
	</div>
</ng-container>
<div *ngIf="editType=='H'&&dataInput=='ck'" class="example-list" #header [style.width.px]="selectpage.size.width" style="padding:80px 0" >
	<div class="layout-wide page-ca  site_wrapper">
        <div class="top_header" >
            <div class="container" style="border:dashed 1px #ccc;" [style.height.px]="hHeight">
				<app-paragraph [addedSlot]="addedHSlot[0]" [addedPara]="addedHPara[0]" class="docItem" [content]="savedHContent"  [insert]='selectedInsert[0]'  (outHtml)="headerContent($event)" (selected)="addLib=true; selectedEditor='H' "></app-paragraph>
			</div>
        </div>

    </div>
</div>
<div *ngIf="editType=='H'&&dataInput=='HTML'" class="example-list" #header1 [style.width.px]="selectpage.size.width" style="padding:80px 0; position:relative;" >
	<div class="layout-wide page-ca  site_wrapper">
        <div class="top_header" >
			<label class="sampleTitle ml-3">Your Header: </label>
			<!--<button class="btn btn-sm btn-outline-dark mr-3 pb-0 float-sm-right" data-toggle="modal" data-target="#srcModal"  (click)='uploadHtml("headers",0)'>Upload Html</button>-->
			<button  [disabled]="allowEdit!='Y'" class="btn btn-sm btn-outline-dark mr-3 pb-0 float-sm-right" (click)='editHtml("headers",0);htmlShow=true'>Editor Html</button>
            
           <!-- <div class="container" style="border:dashed 1px #ccc;height:80px; border:1px dashed #ccc; overflow:hidden" [innerHTML]="savedHTML?.changingThisBreaksApplicationSecurity|safeHtml">
				
			</div>-->
			<div class="iframewrapper">
				<iframe *ngIf="savedHTML?.changingThisBreaksApplicationSecurity" frameborder="0" style="width:100%;border:dashed 1px #ccc;min-height:80px; margin: 0;padding: 0;overflow:hidden" [srcdoc]="savedHTML?.changingThisBreaksApplicationSecurity|safeHtml"></iframe>
			</div>
        </div>

    </div>
</div>
<div *ngIf="editType=='H'" class="example-list" [style.width.px]="selectpage.size.width" style="padding:80px 0; margin-top:40px; position:relative;" >
	<div class="layout-wide page-ca  site_wrapper">
        <div class="top_header">
			<button  [disabled]="allowEdit!='Y'" class="float-btn btn btn-sm btn-outline-light" data-toggle="modal" data-target="#viewerModal"  (click)='copySrc("headers",0)'>Copy Source</button>
            <p class="sampleTitle">Sample Header: </p>
			<div style="border:dashed 1px #ccc;padding:0">             
				<img style="width:100%; height:100%;"  [src]="samples?.headers[0].imageurl">
            </div>
			
        </div>

    </div>
</div>
<div *ngIf="editType=='F'&&dataInput=='ck'" class="example-list" #footer [style.width.px]="selectpage.size.width" style="padding:80px 0" >
	<div class="layout-wide page-ca  site_wrapper" style="">
        <div class="top_header">
            <div class="container" style="border:dashed 1px #ccc;" [style.height.px]="fHeight">
				<app-paragraph [addedSlot]="addedFSlot[0]" [addedPara]="addedFPara[0]" class="docItem" [content]="savedFContent"   [insert]='selectedInsert[0]'  (outHtml)="footerContent($event)" (selected)="addLib=true;  selectedEditor='F' "></app-paragraph>
			</div>
			
        </div>

    </div>
</div>
<div *ngIf="editType=='F'&&dataInput=='HTML'" class="example-list" #footer1 [style.width.px]="selectpage.size.width" style="padding:80px 0; position:relative;" >
	<div class="layout-wide page-ca  site_wrapper">
        <div class="top_header" >
			<label class="sampleTitle ml-3">Your Footer: </label>
			<!--<button class="btn btn-sm btn-outline-dark mr-3 pb-0 float-sm-right" data-toggle="modal" data-target="#srcModal"  (click)='uploadHtml("headers",0)'>Upload Html</button>-->
			<button  [disabled]="allowEdit!='Y'" class="btn btn-sm btn-outline-dark mr-3 pb-0 float-sm-right"  (click)='editHtml("footers",0); htmlShow=true'>Editor Html</button>
            
            <!--<div class="container" style="border:dashed 1px #ccc;height:80px; border:1px dashed #ccc; overflow:hidden" [innerHTML]="savedHTML?.changingThisBreaksApplicationSecurity|safeHtml">
			</div>-->
			<div class="iframewrapper">
				<iframe *ngIf="savedHTML?.changingThisBreaksApplicationSecurity" frameborder="0" onload="this.style.height=(this.contentWindow.document.body.scrollHeight+4)+'px';" style="width:100%;border:dashed 1px #ccc;min-height:80px; margin: 0;padding: 0;overflow:hidden" [srcdoc]="savedHTML?.changingThisBreaksApplicationSecurity|safeHtml"></iframe>
			</div>
        </div>

    </div>
</div>
<div *ngIf="editType=='F'" class="example-list" [style.width.px]="selectpage.size.width" style="padding:80px 0; margin-top:40px; position:relative" >
	<div class="layout-wide page-ca  site_wrapper" style="">
        <div class="top_header">
			<button  [disabled]="allowEdit!='Y'" class="float-btn btn btn-sm btn-outline-light"  data-toggle="modal" data-target="#viewerModal" (click)='copySrc("footers", 0)'>Copy Source</button>
            <p class="sampleTitle">Sample Footer: </p>
			<div style="border:dashed 1px #ccc;padding:0">             
				<img style="width:100%; height:100%;"  [src]="samples?.footers[0].imageurl">
            </div>
			
        </div>

    </div>
</div>
<div *ngIf="editType=='F'" class="example-list" [style.width.px]="selectpage.size.width" style="padding:80px 0; margin-top:40px; position:relative" >
	<div class="layout-wide page-ca  site_wrapper" style="">
        <div class="top_header">
			<button  [disabled]="allowEdit!='Y'" class="float-btn btn btn-sm btn-outline-light" data-toggle="modal" data-target="#viewerModal" (click)='copySrc("footers", 1)'>Copy Source</button>
            <p class="sampleTitle">Sample Footer: </p>
			<div style="border:dashed 1px #ccc;padding:0">             
				<img istyle="width:100%; height:100%;"  [src]="samples?.footers[1].imageurl">
            </div>
			
        </div>

    </div>
</div>
</div>
</div>
<div class="col-md-2 toolContainer">
<!-- Nav tabs -->
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a class="nav-link active" data-toggle="tab" href="#home">Tools</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#menu1">Saved Files</a>
    </li>   
  </ul>
  <!-- Tab panes -->
  <div class="tab-content">
    <div id="home" class="container tab-pane active"><br>
	<div class="toolGroup">
	
	<div class="row mt-2 mb-3" >
		<div class="col-md-9">
		<input class="typeIput ml-2" disabled type="radio" id="ck" name="dataType" [ngModel]="dataInput" value="ck" (change)="dataInput='ck'">
		<label class="typeLabel" for="ck">Editor</label>
		<input class="typeIput ml-4" [disabled]="allowEdit!='Y'" type="radio" id="html" name="dataType" [ngModel]="dataInput" value="HTML" (change)="dataInput='HTML'">
		<label class="typeLabel" for="html">HTML Source Editor</label>
		</div>
		<!--<div class="col-sm-6">
		<button class="btn-block btn btn-outline-success btn-small toolBtn" title="Add Paragraph" (click)='addPara()'>Paragraph</button>
		</div>-->
		<!--<div class="col-sm-6">
		<button class="btn-block btn btn-outline-success btn-small toolBtn" title="Add Table" (click)='addComp()'>Table</button>"{'border':selectpage.type==='portrait'? '1px solid yellow':'none'}"
		</div>-->
		<button  [disabled]="allowAdd!='Y'" class="col-md-5 btn btn-black btn-small m-1 p-1 toolBtn"  [ngStyle]="{border:editType=='C'?'1px solid #C2D63F':'none'}" title="Create New Cover" (click)='newCover()'>Create New Cover</button>
		<button  [disabled]="allowAdd!='Y'||allowEdit!='Y'" class="col-md-5 btn btn-black btn-small m-1 p-1 toolBtn" (click)='saveCover()'>Save Cover Page</button>
		<!--<button class="col-md-5 btn btn-black btn-small m-1 p-1 toolBtn" title="Save Cover Page" (click)='updateCover()'>Update Cover Page</button>
		<button class="col-md-5 btn btn-black btn-small m-1 p-1 toolBtn" title="Save Template" (click)='saveTemplate()'>Save Template</button>
		<button class="col-md-5 btn btn-black btn-small m-1 p-1 toolBtn" title="Save Template" (click)='updateTmp()'>Update Template</button>
		<button class="col-md-5 btn btn-black btn-small m-1 p-1 toolBtn" title="Get Cover Data" (click)='getCoverData()'>test</button>-->
		<button  [disabled]="allowEdit!='Y'" class="col-md-5 btn btn-black btn-small m-1 p-1 toolBtn" (click)='preview()'>Preview PDF</button>
		<!--<button class="col-md-5 btn btn-black btn-small m-1 p-1 toolBtn" data-target='#fileModal' data-toggle="modal" title="Upload Image">upload</button>-->
		<button  [disabled]="allowEdit!='Y'" class="col-md-5 btn btn-black btn-small m-1 p-1 toolBtn" (click)='newPage()'>Add More Page</button>
		<hr class="col-md-12 line">
		<button  [disabled]="allowAdd!='Y'" class="col-md-5 btn btn-black btn-small m-1 p-1 toolBtn" [ngStyle]="{border:editType=='H'?'1px solid #C2D63F':'none'}" (click)='newHeader()'>New Header</button>
		<button class="col-md-5 btn btn-black btn-small m-1 p-1 toolBtn" [disabled]="allowAdd!='Y'||allowEdit!='Y'||(!hContent && hContent!=''&&!this.saveHFHtml&&editType=='H')" (click)='saveHF("HEADER")'>Save Header</button>
		<hr class="col-md-12 line">
		<button  [disabled]="allowAdd!='Y'" class="col-md-5 btn btn-black btn-small m-1 p-1 toolBtn" [ngStyle]="{border:editType=='F'?'1px solid #C2D63F':'none'}" (click)='newFooter()'>New Footer</button>
		<button class="col-md-5 btn btn-black btn-small m-1 p-1 toolBtn"  [disabled]="allowAdd!='Y'||allowEdit!='Y'||(!fContent&&!this.saveHFHtml&&editType=='F')" (click)='saveHF("FOOTER")'>Save Footer</button>
		<hr class="col-md-12 line">
		
		<button [disabled]="allowAdd!='Y'" class="col-md-5 btn-block btn btn-black btn-small m-1 p-1 toolBtn" data-toggle="modal" data-target="#fileModal" (click)='uploadType="IMAGE"'>Upload Image</button>
		<button [disabled]="allowEdit!='Y'" class="col-md-5 btn btn-black btn-small m-1 p-1 toolBtn" (click)='chooseBackground()'>Choose Background</button>
		<button [disabled]="allowEdit!='Y'" class="col-md-5 btn btn-black btn-small m-1 p-1 toolBtn" (click)='insertPageNo()'>Page No</button>
		<button [disabled]="allowEdit!='Y'" class="col-md-5 btn btn-black btn-small m-1 p-1 toolBtn" (click)='insertPageNo("t")'>Page No/Total</button>
		<!--<button class="col-md-5 btn btn-black btn-small m-1 p-1 toolBtn" (click)='insertTitle("doc")'>Document Title</button>
		<button class="col-md-5 btn btn-black btn-small m-1 p-1 toolBtn" (click)='insertTitle("sec")'>Section Title</button>-->
		<button  [disabled]="allowEdit!='Y'" class="col-md-5 btn btn-black btn-small m-1 p-1 toolBtn" (click)='insertImage()'>Insert Image</button>
		<!--<button class="col-md-5 btn btn-black btn-small m-1 p-1 toolBtn" title="Add New Cover" (click)='saveFooter()'>Insert Title</button>
		<button class="col-md-5 btn btn-black btn-small m-1 p-1 toolBtn" title="Add New Cover" (click)='saveFooter()'>Save Footer</button>
		<button class="col-md-5 btn btn-black btn-small m-1 p-1 toolBtn" title="Add New Cover" (click)='saveFooter()'>Save Footer</button>-->		
		
	</div>
		<input #file type="file" style="display: none;" (change)="uploadImage()"  accept='.png,.PNG,.jpg,.JPG, .jpeg,.JPEG'/>
		<div>
		<hr class="line">
		<app-reportinfo [user]="current" (info)="onInfo($event)" (getLogo)="onSavedLogo($event)" [hide]="allowEdit!='Y'">
		</app-reportinfo>
	</div>
	</div>
      </div>
    <div id="menu1" class="container tab-pane fade"><br>
		<div style="width:100%; height:88vh; margin:0; padding:0; overflow:auto">
		<strong>Cover Pages</strong>
			<table style="width:90%; border: 1px solid black;  border-collapse: collapse;font-size:11px">
				<thead>
					<tr>
						<th>Cover Page</th>
						<th>Action</th>																
					</tr>
				</thead>
					<tbody>
						<ng-container *ngFor="let cover of covers;">
							<tr>
								<td><a href="javascript:void(0)" (click)="getCoverPage(cover.COVERPAGE_ID)">{{cover.COVERPAGE_TITLE}}</a></td>
								<td>
									<a class="btn iconBtn mr-1"><i class="far fa-question-circle" (mouseenter)="op10.show($event)" (mouseout)="op10.hide()"></i></a>
									<a class="btn iconBtn mr-1" title="Delete" [ngClass]="{'disabled':allowAdd!='Y'}"><i class="far fa-trash-alt " (click)="deleteCover(cover.COVERPAGE_ID)"></i></a>
									<a class="btn iconBtn mr-1" title="Copy"  [ngClass]="{'disabled':allowAdd!='Y'}" (click)="copyCover(cover)"><i class="far fa-clone"></i></a>
									<p-overlayPanel #op10 [appendTo]="'body'" [dismissable]="true" [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '240px'}">
										<ng-template pTemplate>
											<div style="margin: 0; color:white;max-height:240px; overflow:auto; font-size:11px"> 
												<strong style="color:#C2D63F">Created by : </strong>{{cover.CREATED_BY}}<br> 
												<strong style="color:#C2D63F">Updated by : </strong>{{cover.UPDATED_BY}}<br> 
												<strong style="color:#C2D63F">Date Created : </strong>{{cover.DATE_CREATED}}<br> 
												<strong style="color:#C2D63F">Date Updated : </strong>{{cover.DATE_UPDATED}}<br> 
											</div>
										</ng-template>
									</p-overlayPanel>
								</td>								
							</tr>
						</ng-container>
					</tbody>
				</table>
				<hr class="line">
				<strong>Headers</strong>
				<table style="width:90%; border: 1px solid black;  border-collapse: collapse;font-size:11px">
				<thead>
					<tr>
						<th>Header</th>
						<th>Action</th>																
					</tr>
				</thead>
					<tbody>
						<ng-container *ngFor="let header of headers;">
							<tr>
								<td><a href="javascript:void(0)" (click)="getHF(header.HEADERFOOTER_ID)">{{header.HF_TITLE}}</a></td>
								<td>
									<a class="btn iconBtn mr-1"><i class="far fa-question-circle" (mouseenter)="op11.show($event)" (mouseout)="op11.hide()"></i></a>
									<a class="btn iconBtn mr-1" title="Delete"  [ngClass]="{'disabled':allowAdd!='Y'}"><i class="far fa-trash-alt " (click)="deleteHF('HEADER', header.HEADERFOOTER_ID)"></i></a>
									<a class="btn iconBtn mr-1" title="Copy"  [ngClass]="{'disabled':allowAdd!='Y'}" (click)="copyHF(header.HEADERFOOTER_ID)"><i class="far fa-clone"></i></a>
									<p-overlayPanel #op11 [appendTo]="'body'" [dismissable]="true" [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '240px'}">
										<ng-template pTemplate>
											<div style="margin: 0; color:white;max-height:240px; overflow:auto; font-size:11px"> 
												<strong style="color:#C2D63F">Created by : </strong>{{header.CREATED_BY}}<br> 
												<strong style="color:#C2D63F">Updated by : </strong>{{header.UPDATED_BY}}<br> 
												<strong style="color:#C2D63F">Date Created : </strong>{{header.DATE_CREATED}}<br> 
												<strong style="color:#C2D63F">Date Updated : </strong>{{header.DATE_UPDATED}}<br> 
											</div>
										</ng-template>
									</p-overlayPanel>
								</td>								
							</tr>
						</ng-container>
					</tbody>
				</table>
				<hr class="line">
				<strong>Footers</strong>
				<table style="width:90%; border: 1px solid black;  border-collapse: collapse;font-size:11px">
				<thead>
					<tr>
						<th>Footer</th>
						<th>Action</th>																
					</tr>
				</thead>
					<tbody>
						<ng-container *ngFor="let footer of footers;">
							<tr>
								<td><a  href="javascript:void(0)" (click)="getHF(footer.HEADERFOOTER_ID)">{{footer.HF_TITLE}}</a></td>
								<td>
									<a class="btn iconBtn mr-1"><i class="far fa-question-circle" (mouseenter)="op12.show($event)" (mouseout)="op12.hide()"></i></a>
									<a class="btn iconBtn mr-1" title="Delete" [ngClass]="{'disabled':allowAdd!='Y'}"><i class="far fa-trash-alt " (click)="deleteHF('FOOTER', footer.HEADERFOOTER_ID)"></i></a>
									<a class="btn iconBtn mr-1" title="Copy" [ngClass]="{'disabled':allowAdd!='Y'}" (click)="copyHF(footer.HEADERFOOTER_ID)"><i class="far fa-clone"></i></a>
									<p-overlayPanel #op12 [appendTo]="'body'" [dismissable]="true" [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '240px'}">
										<ng-template pTemplate>
											<div style="margin: 0; color:white;max-height:240px; overflow:auto; font-size:11px"> 
												<strong style="color:#C2D63F">Created by : </strong>{{footer.CREATED_BY}}<br> 
												<strong style="color:#C2D63F">Updated by : </strong>{{footer.UPDATED_BY}}<br> 
												<strong style="color:#C2D63F">Date Created : </strong>{{footer.DATE_CREATED}}<br> 
												<strong style="color:#C2D63F">Date Updated : </strong>{{footer.DATE_UPDATED}}<br> 
											</div>
										</ng-template>
									</p-overlayPanel>
								</td>								
							</tr>
						</ng-container>
					</tbody>
				</table>
</div>				
    </div>
   
  </div>
	
</div>
</div>
</div>
 <app-panel [header]="'Profile Management'" [opened]="showLogo" [align]="'right'" [fixed]="[-10, 54]" (didClosed)="showLogo = null">
    <ng-container name="body">
      <app-logo *ngIf="userInfo" class="w-100 h-100" [logoInfo]="logoInfo" [userInfo]='userInfo' (editReport)="onEditReport($event)" (logOut)='logOut()'></app-logo>
    </ng-container>
  </app-panel>
<div id="imgModal" class="modal fade" data-backdrop='false'>
	<div class="modal-dialog modal-lg modal-dialog-centered ">
	<div class="modal-content">
		<!-- Modal Header -->
        <div class="modal-header">
          <h6 id="" class="modal-title">Select Image</h6>
		  <a href='javascript:void(0)' class="btn btn-outline-success btn-sm  pr-1 pl-1 pt-1 pb-1 ml-3" title="Add Image" (click)='upload("BKIMAGE")'><i class="fas fa-cloud-upload-alt"></i></a>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        
        <!-- Modal body -->
        <div class="modal-body">
				<span id="spinner" class="fa fa-spinner fa-spin" style="font-size:24px; display:none"></span>
				<div name="form">
					<ng-container *ngFor="let bk of bks">
						<img class="bkImage" [ngClass]="{'active':selectedImage?.COMP_IMAGE_ID==bk.COMP_IMAGE_ID}"style="display:inline-block; width:100px; height:100px; margin:10px" title='Select this image' [src]="bk.FILE_TN_URL" (click)='selectImg(bk)'>
					</ng-container>
				</div>				
				
		
        </div>

	</div>
	</div>
	</div>
	<div id="updateModal" class="modal fade" data-backdrop='false'>
	<div class="modal-dialog modal-sm modal-dialog-centered ">
	<div class="modal-content">
		<!-- Modal Header -->
        <div class="modal-header">
          <h6 id="" class="modal-title">Update Cover Page</h6>
		  <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        
        <!-- Modal body -->
        <div class="modal-body">
				<div>
					<p>Select Cover Page for Update : <p>
					<select *ngIf="covers" class="form-control">
					<ng-container *ngFor="let cover of covers">
						<option></option>
						<option [value]='cover.COVERPAGE_ID' [selected]='current?.COVERPAGE_ID==cover.COVERPAGE_ID'>{{cover.COVERPAGE_TITLE}}</option>
					</ng-container>
					</select>
					<button class="btn btn-outline-success btn-sm btn-block mt-3">Update</button>
				
				</div>				
				
		
        </div>

	</div>
	</div>
	</div> 
<div id="insertModal" class="modal fade" data-backdrop='false'>
	<div class="modal-dialog modal-lg modal-dialog-centered ">
	<div class="modal-content" style="background:#444; color:#ccc">
		<!-- Modal Header -->
        <div class="modal-header">
          <h6 id="" class="modal-title">Select Image</h6>
		  <!--<a href='javascript:void(0)' class="btn btn-outline-success btn-sm  pr-1 pl-1 pt-0 pb-0 ml-3" title="Insert Image" (click)='insertImage()'><i class="fas fa-check"></i></a>-->
		  <a href='javascript:void(0)' class="btn btn-outline-success btn-sm  pr-1 pl-1 pt-1 pb-1 ml-3" title="Add Image" (click)='upload("IMAGE")'><i class="fas fa-cloud-upload-alt"></i></a>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        
        <!-- Modal body -->
        <div class="modal-body">
				<span id="spinner" class="fa fa-spinner fa-spin" style="font-size:24px; display:none"></span>
				<div name="form" style="max-height:600px; overflow-y:auto">
					<ng-container *ngFor="let other of others">
					<div style="display:inline-block; width:100px; height:140px; margin:10px">
						<div style="display: flex;flex-direction: column; ">
							<img class="bkImage" style="display:inline-block; width:100px; height:100px; " title='Select this image' [src]="other.FILE_TN_URL" (click)='selectInsert(other)'>
							<a class="btn btn-outline-dark btn-sm center-block uploadBtn mt-2" (click)="copyUrl(other.FILE_URL)">Copy Url</a>
						</div>
					</div>
					</ng-container>
				</div>				
				
		
        </div>

	</div>
	</div>
	</div>
	<div id="marginModal" class="modal fade" data-backdrop='false'>
	<div class="modal-dialog modal-sm modal-dialog-centered ">
	<div class="modal-content" style="background:#444; color:#ccc">
		<!-- Modal Header -->
        <div class="modal-header">
          <h6 id="" class="modal-title">Set Margin Size</h6>
		  <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        
        <!-- Modal body -->
        <div class="modal-body">
			<label class="col-md-7">Margin Top</label><input  class="col-md-4" type='number' [(ngModel)]="pageMargin.top"/>px<br>
			<label class="col-md-7">Margin Bottom</label><input  class="col-md-4" type='number' [(ngModel)]="pageMargin.bottom"/>px<br>	
			<label class="col-md-7">Margin Left</label><input  class="col-md-4" type='number' [(ngModel)]="pageMargin.left"/>px<br>
			<label class="col-md-7">Margin Right</label><input  class="col-md-4" type='number' [(ngModel)]="pageMargin.right"/>px<br>		
        </div>

	</div>
	</div>
	</div>
<div id="bkModal" class="modal fade" data-backdrop='false'>
	<div class="modal-dialog modal-lg modal-dialog-centered ">
	<div class="modal-content" style="background:#444; color:#ccc">
		<!-- Modal Header -->
        <div class="modal-header">
          <h6 id="" class="modal-title">Choose Background Image</h6>
		  <!--<a href='javascript:void(0)' class="btn btn-outline-success btn-sm  pr-1 pl-1 pt-0 pb-0 ml-3" title="Insert Image" (click)='insertImage()'><i class="fas fa-check"></i></a>-->
		  <a href='javascript:void(0)' class="btn btn-outline-success btn-sm  pr-1 pl-1 pt-1 pb-1 ml-3" title="Add Image" (click)='upload("BKIMAGE")'><i class="fas fa-cloud-upload-alt"></i></a>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        
        <!-- Modal body -->
        <div class="modal-body">
				<div name="form"  style="max-height:600px; overflow-y:auto">
					<ng-container *ngFor="let bk of bks">
						<div style="display:inline-block; width:100px; height:140px; margin:10px">
							<div style="display: flex;flex-direction: column; ">
								<img class="bkImage"  title='Select this image' [src]="bk.FILE_TN_URL" (click)='selectBK(bk.FILE_URL)'>
								<a class="btn btn-outline-dark btn-sm center-block uploadBtn mt-2" (click)="copyUrl(bk.FILE_URL)">Copy Url</a>
							</div>
						</div>
					</ng-container>
				</div>				
				
		
        </div>

	</div>
	</div>
	</div>
	<div id="uploadModal" class="modal fade" data-backdrop='false'>
	<div class="modal-dialog modal-lg modal-dialog-centered ">
	<div class="modal-content" style="background:#444; color:#ccc">
		<!-- Modal Header -->
        <div class="modal-header">
          <h6 id="" class="modal-title">Choose upload type</h6>
		  <!--<a href='javascript:void(0)' class="btn btn-outline-success btn-sm  pr-1 pl-1 pt-0 pb-0 ml-3" title="Insert Image" (click)='insertImage()'><i class="fas fa-check"></i></a>-->
			<button type="button" class="close" data-dismiss="modal">&times;</button>
		</div>
        
        <!-- Modal body -->
        <div class="modal-body">
			<select [(ngModel)]="uploadType">
				<option value="other">Other Image</option>
				<option value="bk">Background Image</option>
				<!--<option value="rpt">Report Image</option>
				<option value="file">File</option>-->
			</select>
			<a href='javascript:void(0)' class="btn btn-outline-success btn-sm  pr-1 pl-1 pt-1 pb-1 ml-3" title="Add Image" (click)='upload()'><i class="fas fa-cloud-upload-alt"></i></a>
				<span id="spinner" class="fa fa-spinner fa-spin" style="font-size:24px; display:none"></span>
				<div name="form" *ngIf="uploadType=='bk'">
					<ng-container *ngFor="let bk of bks">
						<img class="bkImage" style="display:inline-block; width:100px; height:100px; margin:10px" [src]="bk.FILE_TN_URL">
					</ng-container>
					
				</div>	
				<div *ngIf="uploadType=='other'">
					<ng-container *ngFor="let other of others">
						<img class="bkImage" style="display:inline-block; width:100px; height:100px; margin:10px" [src]="other.FILE_TN_URL">
					</ng-container>
				</div>
								
				
		
        </div>

	</div>
	</div>
	</div>
</div>
<div id="fileModal"  #fileModal class="modal fade" data-backdrop='false'>
	<div class="modal-dialog modal-lg modal-dialog-centered ">
	<div class="modal-content" style="background:#444; color:#ccc">
	    <div class="modal-body">
		<button type="button" class="close" data-dismiss="modal">&times;</button>
		
			
			<div style="width:100%">
	<ul class="nav nav-tabs">
    <!--<li class="nav-item">
		<a class="nav-link" [ngClass]="{'active':uploadType=='FILE'}" data-toggle="tab" href="#files">Project Documents</a>		
    </li>
    <li class="nav-item">
      <a class="nav-link" [ngClass]="{'active':uploadType=='PHOTO'}" data-toggle="tab" href="#photos">Photo Gallary</a>
    </li>-->
    <li class="nav-item">
      <a class="nav-link active" data-toggle="tab" href="#images" >Company Images </a>
    </li>	
  </ul>
  <!-- Tab panes -->
  <div class="tab-content">
    
			
			<!--<div id="files" class="container tab-pane" [ngClass]="{'active':uploadType=='FILE','fade':uploadType!='FILE'}" style="width:100%; padding:0; max-height:600px; overflow:auto">
			<a href='javascript:void(0)' class="btn btn-outline-success btn-sm  pr-1 pl-1 pt-0 pb-0 float-right m-1" (click)='upload("FILE")'>Upload</a>
				<span id="spinner" class="fa fa-spinner fa-spin" style="font-size:24px; display:none"></span>
			<br>
			<p-table #dt [value]="uploadedFiles" [columns]="cols6">
				<ng-template pTemplate="caption">
					<i class="pi pi-search"></i>
                    <input type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Global Search" style="font-size:11px; padding:2px"/>
				</ng-template>
						<ng-template pTemplate="header"  let-columns>
                            <tr>
								<th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width}" style="padding:1px; font-size:11px">
									{{col.header}} <p-sortIcon field="code"></p-sortIcon>               
								</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                            <tr>
                                <td *ngFor="let col of columns" [ngStyle]="{'width': col.width}" style="padding:1px; font-size:11px">
									<span *ngIf="col.field=='FILE_NAME'"><a [href]="rowData.FILE_URL" target=_blank>{{rowData[col.field]}}</a></span>
									<span *ngIf="col.field!=='FILE_NAME'">{{rowData[col.field]}}</span>																
									<i  *ngIf="col.field=='FILE_NAME'" class="brn btn-outline-light btn-small far fa-trash-alt float-right mt-1"  style="color:#C2D63F"(click)="deleteFile(rowData, 'FILE')"></i>
									
								</td>																	
                            </tr>
                        </ng-template>
                    </p-table>					
				</div>-->					
				<div id="images" class="container tab-pane" [ngClass]="{'active':uploadType=='IMAGE'||uploadType=='BKIMAGE'||uploadType=='LOGO', 'fade':uploadType!='IMAGE'&&uploadType!='BKIMAGE'&&uploadType!='LOGO'}" >
					<div style="color:#C2D63F; font-size:.9em; padding-left:10px">
						<label class="radio-inline mr-2">
							<input type="radio" name="uploadimage" [checked]="imgGroup=='other'" (change)="imgGroup='other'"> 
							Images 
						</label> 
						<label class="radio-inline ml-3">
							<input type="radio" name="uploadimage" [checked]="imgGroup=='bk'" (change)="imgGroup='bk'">
							Background Images
						</label> 
						<label class="radio-inline ml-3"> 
							<input type="radio" name="uploadimage" [checked]="imgGroup=='logo'" (change)="imgGroup='logo'">
							Logos
						</label>
					</div>
				<div *ngIf="imgGroup=='other'"  style="padding:0; max-height:600px;  overflow-y: auto;overflow-x: hidden;">
				<div class="row" style="width:98%">
				<div *ngIf="uploadTotal!==0&&uploadTotal!==100&&uploadType=='IMAGE'&&imgGroup=='other'" class="progress-wrapper col-md-10" style="height:10px;margin:4px">
					<div class="progress">
						<div class="progress-bar progress-bar-striped" style="height:10px;" [ngStyle]="{'width': uploadTotal + '%'}">
							{{uploadFiles}} of {{uploadNo}}
						</div>
					</div>
				</div>
				<a href='javascript:void(0)' class="btn uploadBtn ml-auto m-1" [ngClass]="{'disabled':uploadTotal!==0&&uploadTotal!==100}" (click)='upload("IMAGE")'>Upload</a>
				<span *ngIf="loading" class="fa fa-spinner fa-spin float-right" style="font-size:16px;color:rgb(195,212,47)"></span>
			</div>
					<!--<ng-container *ngFor="let other of others">
						<img class="bkImage" style="display:inline-block; width:100px; height:100px; margin:10px" [src]="other.FILE_TN_URL">
					</ng-container>-->
					<ul class="widget-item-list">
						<li class="item" *ngFor="let other of others">
							<div class="img-wrapper">
								<img *ngIf="other.FILE_TN_URL" [src]="other.FILE_TN_URL" class="img img-fluid"/>
							</div>
							<div *ngIf="other.FILE_DESCRIPTION.length>0" class="title" title="Click to Edit Description"  (click)="op41.toggle($event)">{{other.FILE_DESCRIPTION.substring(0, 40)}}<span *ngIf="other.FILE_DESCRIPTION.length>40"> . . . </span></div>
							<div *ngIf="other.FILE_DESCRIPTION.length==0" class="title" title="Click to Edit Description"  (click)="op41.toggle($event)" style="color:rgb(195,212,47);">Click to Edit File Description</div>
							<hr class="line">
							<a href="javascript:void(0);" class="remove" (click)="op41.toggle($event)"><i class="far fa-edit" style="font-size: 10px;"></i></a>
							<a href="javascript:void(0);" class="remove" (click)="deleteFile(other, 'IMAGE')"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
							<a href="javascript:void(0);" class="remove" title="Copy Url" (click)="copyUrl(other.FILE_URL)"><i class="far fa-clone" style="font-size: 10px;"></i></a>
							
							<p-overlayPanel #op41 [appendTo]="fileModal" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '300px'}">
                                <ng-template pTemplate>
									<div style="margin: 0; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
										<strong>File Description : </strong><br> 
										<textarea class="col-md-12" rows=6 maxlength="200" style="font-size:11px; z-index:1010">{{other.FILE_DESCRIPTION}}</textarea>
										<button class="btn m-0 uploadBtn float-right" (click)="updateFile(other, 'IMAGE', $event)">Update</button>
									</div>
                                </ng-template>
                            </p-overlayPanel>
						</li>
                 
                  
					</ul>
				</div>
				
				<div *ngIf="imgGroup=='bk'"  style="padding:0; max-height:600px;  overflow-y: auto;overflow-x: hidden;">
					<div class="row" style="width:98%">
				<div *ngIf="uploadTotal!==0&&uploadTotal!==100&&uploadType=='BKIMAGE'&&imgGroup=='bk'" class="progress-wrapper col-md-10" style="height:10px;margin:4px">
					<div class="progress">
						<div class="progress-bar progress-bar-striped" style="height:10px;" [ngStyle]="{'width': uploadTotal + '%'}">
							{{uploadFiles}} of {{uploadNo}}
						</div>
					</div>
				</div>
				<a href='javascript:void(0)' class="btn uploadBtn ml-auto m-1" [ngClass]="{'disabled':uploadTotal!==0&&uploadTotal!==100}" (click)='upload("BKIMAGE")'>Upload</a>
				<span *ngIf="loading" class="fa fa-spinner fa-spin float-right" style="font-size:16px;color:rgb(195,212,47)"></span>
			</div>	
					<!--<ng-container *ngFor="let bk of bks">
						<img class="bkImage" style="display:inline-block; width:100px; height:100px; margin:10px" [src]="bk.FILE_TN_URL">
					</ng-container>-->
					<ul class="widget-item-list">
						<li class="item" *ngFor="let bk of bks">
							<div class="img-wrapper">
								<img *ngIf="bk.FILE_TN_URL" [src]="bk.FILE_TN_URL" class="img img-fluid"/>
							</div>
							<div *ngIf="bk.FILE_DESCRIPTION.length>0" class="title" title="Click to Edit Description"  (click)="op42.toggle($event)">{{bk.FILE_DESCRIPTION.substring(0, 40)}}<span *ngIf="bk.FILE_DESCRIPTION.length>40"> . . . </span></div>
							<div *ngIf="bk.FILE_DESCRIPTION.length==0" class="title" title="Click to Edit Description"  (click)="op42.toggle($event)" style="color:rgb(195,212,47);">Click to Edit File Description</div>
							<hr class="line">
							<a href="javascript:void(0);" class="remove" (click)="op42.toggle($event)"><i class="far fa-edit" style="font-size: 10px;"></i></a>
							<a href="javascript:void(0);" class="remove" (click)="deleteFile(bk, 'BKIMAGE')"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
							<a href="javascript:void(0);" class="remove" title="Copy Url" (click)="copyUrl(bk.FILE_URL)"><i class="far fa-clone" style="font-size: 10px;"></i></a>
							
							<p-overlayPanel #op42 [appendTo]="fileModal" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '300px'}">
                                <ng-template pTemplate>
									<div style="margin: 0; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
										<strong>File Description : </strong><br> 
										<textarea class="col-md-12" rows=6 maxlength="200" style="font-size:11px; z-index:1010">{{bk.FILE_DESCRIPTION}}</textarea>
										<button class="btn m-0 uploadBtn float-right" (click)="updateFile(bk, 'BKIMAGE', $event)">Update</button>
									</div>
                                </ng-template>
                            </p-overlayPanel>
						</li>
                 
                  
					</ul>
				</div>
				
				<div *ngIf="imgGroup=='logo'"  style="padding:0; max-height:600px;  overflow-y: auto;overflow-x: hidden;">
				<div class="row" style="width:98%">
						<div *ngIf="uploadTotal!==0&&uploadTotal!==100&&uploadType=='LOGO'&&imgGroup=='logo'" class="progress-wrapper col-md-10" style="height:10px;margin:4px">
							<div class="progress">
								<div class="progress-bar progress-bar-striped" style="height:10px;" [ngStyle]="{'width': uploadTotal + '%'}">
									{{uploadFiles}} of {{uploadNo}}
								</div>
							</div>
						</div>
						<a href='javascript:void(0)' class="btn uploadBtn ml-auto m-1" [ngClass]="{'disabled':uploadTotal!==0&&uploadTotal!==100}" (click)='upload("LOGO")'>Upload</a>
						<span *ngIf="loading" class="fa fa-spinner fa-spin float-right" style="font-size:16px;color:rgb(195,212,47)"></span>
					</div>
					<!--<ng-container *ngFor="let logo of logos">
						<img class="bkImage" style="display:inline-block; width:100px; height:100px; margin:10px" [src]="logo.FILE_TN_URL">
					</ng-container>-->
					<ul class="widget-item-list">
						<li class="item" *ngFor="let logo of logos">
							<div class="img-wrapper">
								<img *ngIf="logo.FILE_TN_URL" [src]="logo.FILE_TN_URL" class="img img-fluid"/>
							</div>
							<div *ngIf="logo.FILE_DESCRIPTION.length>0" class="title" title="Click to Edit Description"  (click)="op43.toggle($event)">{{logo.FILE_DESCRIPTION.substring(0, 40)}}<span *ngIf="logo.FILE_DESCRIPTION.length>40"> . . . </span></div>
							<div *ngIf="logo.FILE_DESCRIPTION.length==0" class="title" title="Click to Edit Description"  (click)="op43.toggle($event)" style="color:rgb(195,212,47);">Click to Edit File Description</div>
							<hr class="line">
							<a href="javascript:void(0);" class="remove" (click)="op43.toggle($event)"><i class="far fa-edit" style="font-size: 10px;"></i></a>
							<a href="javascript:void(0);" class="remove" (click)="deleteFile(logo, 'LOGO')"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
							<a href="javascript:void(0);" class="remove" title="Copy Url" (click)="copyUrl(logo.FILE_URL)"><i class="far fa-clone" style="font-size: 10px;"></i></a>
							<p-overlayPanel #op43 [appendTo]="fileModal" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '300px'}">
                                <ng-template pTemplate>
									<div style="margin: 0; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
										<strong>File Description : </strong><br> 
										<textarea class="col-md-12" rows=6 maxlength="200" style="font-size:11px; z-index:1010">{{logo.FILE_DESCRIPTION}}</textarea>
										<button class="btn m-0 uploadBtn float-right" (click)="updateFile(logo, 'LOGO', $event)">Update</button>
									</div>
                                </ng-template>
                            </p-overlayPanel>
						</li>
                 
                  
					</ul>
					</div>
				</div>
				<!--<div id="photos" class="container tab-pane pt-2" [ngClass]="{'active':uploadType=='PHOTO','fade':uploadType!='PHOTO' }"  style="width:100%; padding:0; max-height:600px; overflow:auto">
					<a href='javascript:void(0)' class="btn btn-outline-success btn-sm  pr-1 pl-1 pt-0 pb-0 float-right m-1" (click)='upload("PHOTO")'>Upload</a>
						<span id="spinner" class="fa fa-spinner fa-spin" style="font-size:24px; display:none"></span>
					<br>
					<ul class="widget-item-list">
						<li class="item" *ngFor="let photo of photos">
							<div class="img-wrapper">
								<img *ngIf="photo.FILE_TN_URL" [src]="photo.FILE_TN_URL" class="img img-fluid"/>
							</div>
							<span class="title">{{photo.FILE_NAME}}</span>
							<hr class="line">
							<a href="javascript:void(0);" class="remove" (click)="deleteFile(photo, 'PHOTO')"><i class="far fa-edit" style="font-size: 10px;"></i></a>
							<a href="javascript:void(0);" class="remove" (click)="deleteFile(photo, 'PHOTO')"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
							
						</li>
                 
                  
					</ul>
				</div>-->
        </div>
	
	</div>
	</div>
	</div>
	</div>
	</div>
<div id="viewerModal" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="false">
	<div class="modal-dialog modal-dialog-centered" style="max-width:40%">
	<div class="modal-content" style="background-color:#cDcDcD">
		<!-- Modal Header  -->
        <div class="modal-header">
			<h6 class="modal-title">Source Viewer</h6>
			<a href='javascript:void(0)' class="btn btn-outline-dark btn-sm ml-4 pt-0 pb-0" (click)='saveHFHtml()'>Save HTML</a>
          	<button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>        
        <!-- Modal body -->
        <div class="modal-body">
			<div>
				<textarea class="col-md-12" rows=30 [(ngModel)]="sourceCode"></textarea>	
			</div>
		</div>
		</div>
		</div>
	</div>
	<div id="srcModal" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="false">
	<div class="modal-dialog modal-dialog-centered" style="max-width:40%">
	<div class="modal-content" style="background-color:#cDcDcD">
		<!-- Modal Header  -->
        <div class="modal-header">
			<h6 class="modal-title">Source Viewer</h6>
			<a href='javascript:void(0)' class="btn btn-outline-dark btn-sm ml-4 pt-0 pb-0" (click)='testHtml()'>Test HTML</a>
          	<button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>        
        <!-- Modal body -->
        <div class="modal-body">
			<div>
				<textarea class="col-md-12" rows=30 [(ngModel)]="sourceHFCode"></textarea>	
			</div>
		</div>
		</div>
		</div>
	</div>
	<div id="srcCModal" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="false">
	<div class="modal-dialog modal-dialog-centered" style="max-width:40%">
	<div class="modal-content" style="background-color:#cDcDcD">
		<!-- Modal Header  -->
        <div class="modal-header">
			<h6 class="modal-title">Source Viewer</h6>
			<a href='javascript:void(0)' class="btn btn-outline-dark btn-sm ml-4 pt-0 pb-0" (click)='testCHtml(cIndex)'>Test HTML</a>
          	<button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>        
        <!-- Modal body -->
        <div class="modal-body">
			<div>
				<textarea class="col-md-12" rows=30 [(ngModel)]="sourceCCode[cIndex]"></textarea>	
			</div>
		</div>
		</div>
		</div>
	</div>


